module.exports = __webpack_public_path__ + "img/logo.41b7d52e.png";